import { jQuery as $ } from 'mk/jQuery';
import * as msgs from 'mk/msgs';
import { trackReach, TrackReachProduct } from 'mk2/trackReach';

interface LikeMsgs {
    add: string;
    remove: string;
    added: string;
    removed: string;
}

let texts: LikeMsgs = {add: '', remove: '', added: '', removed: ''};

function getState(el: HTMLElement): boolean {
    const t = el.className.match(/state-(\d+)/);
    return t && t[1] === '1';
}

function setState(el: HTMLElement, state: boolean) {
    const $n = $(el);

    if (state) {
        $n.removeClass('state-0').addClass('state-1');
    } else {
        $n.removeClass('state-1').addClass('state-0');
    }

    // we trigger a like-event, it is useful when dynamically building like controls
    $n.trigger('like', {state});

    const newText = state
        ? ($n.data('like-text-remove') || texts.remove)
        : ($n.data('like-text-add') || texts.add);

    $n.find('.state-msg').text(newText);
    $n.find('.state-icon').toggleClass('hidden', state);
}

// FIXME: would be nice to be able to use django.reverse
function getDetailsUrl(sectionEl: HTMLElement) {
    return sectionEl.getAttribute('data-details-url');
}

let loading: boolean = false;
function handleLikersPopup(sectionEl) {
    if (loading) {
        return;
    }

    loading = true;
    const detailsUrl = getDetailsUrl(sectionEl);
    const $popup = $('.like-info-popup');
    if ($popup.attr('data-url') === detailsUrl) { // this item's window is already open, close it
        $popup.remove();
    } else {
        $popup.remove(); // remove any existing ones
        $.ajax({
            type: 'GET',
            url: detailsUrl,
            cache: false,
            dataType: 'text',
            success: (data) => {
                const newPopup = $(data).appendTo($('body'));

                newPopup.on('click', '.like-info-popup-close', (ev) => {
                    $(ev.currentTarget).closest('.like-info-popup').remove();
                })
                .css('left', ($(window).width() - newPopup.outerWidth()) / 2);

                $('.like-info-popup').attr('data-url', detailsUrl);
                loading = false;
            },
            error: (XMLHttpRequest, textStatus, errorThrown) => {
                window.alert(`Cannot get likers, try later. Error: ${textStatus} ${errorThrown}`);
                loading = false;
            },
        });
    }
}

function toggleLike(el: HTMLElement) {

    let state = getState(el);
    state = !state;
    setState(el, state);

    const $el = $(el);
    const $section = $('.like-info-box.' + el.getAttribute('data-like-section-class'));

    $.ajax({
        type: 'POST',
        url: el.getAttribute('data-post-url'),
        cache: false,
        data: {state: state ? 'true' : 'false'},
        success: (data) => {
            msgs.alert(state ?
                ($el.data('like-text-added') || texts.added) :
                ($el.data('like-text-removed') || texts.removed));

            $section
                .find('.like-count').html(data.count).end()
                .toggle(data.count > 0);

            const url = window ? window.location.href : '';
            const details = data.targetPostCommercialDetails;

            if (details) {
                if (details.relatedToDaysWith && details.relatedToDaysWith.length > 0) {
                    details.relatedToDaysWith.forEach((item) => {
                        trackReach(url, TrackReachProduct.DAYS_WITH, item, 'blog',
                        );
                    });
                }
                if (details.relatedToAmbassadorOfBrands && details.relatedToAmbassadorOfBrands.length > 0) {
                    details.relatedToAmbassadorOfBrands.forEach((item) => {
                        trackReach(url, TrackReachProduct.AMBASSADOR, item, 'blog');
                    });
                }
                if (details.relatedToTesting && details.relatedToTesting.length > 0) {
                    details.relatedToTesting.forEach((item) => {
                        trackReach(url, TrackReachProduct.TESTING, item, 'blog');
                    });
                }
            }

            $el.trigger('like-done', {state});
        },
        error: (XMLHttpRequest, textStatus, errorThrown) => {
            window.alert(`The item could not be liked, try later. Error: ${textStatus} ${errorThrown}`);
            setState(el, !state);
        },
    });
}

export function getTexts(): LikeMsgs {
    return texts;
}

export function init(d: LikeMsgs) {
    texts = d;

    $(document).on('click', 'a.like-link', (e) => {
        e.preventDefault();
        toggleLike(e.currentTarget);
    });

    $(document).on('click', 'button.like-info-button', (e) => {
        // this is general code, let's make it as safe as possible
        e.stopPropagation();
        const infobox = $(e.currentTarget).closest('.like-info-box')[0];
        handleLikersPopup(infobox);
        return false;
    });
}
